import React from 'react'
import Modal from 'react-modal'

// 確認・操作結果の通知に使う共通モーダル。
// mode="confirm": キャンセル/実行の2ボタン。mode="notice": OKの1ボタンのみ。
const ConfirmModal = ({ isOpen, mode = 'confirm', title, message, confirmLabel = '実行する', cancelLabel = 'キャンセル', okLabel = 'OK', onConfirm, onCancel, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => (mode === 'confirm' ? onCancel() : onClose())}
            className="bg-white p-6 rounded-lg shadow-lg mx-auto mt-20 relative max-w-md"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        >
            <div className='text-center px-2'>
                {title && <h2 className='font-bold text-purple-800 text-xl mb-2'>{title}</h2>}
                <p className='text-gray-600 text-base text-left mb-6 whitespace-pre-line'>{message}</p>

                {mode === 'confirm' ? (
                    <div className='grid grid-cols-2 gap-4'>
                        <button className='bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg px-4 py-2' onClick={() => onCancel()}>{cancelLabel}</button>
                        <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2' onClick={() => onConfirm()}>{confirmLabel}</button>
                    </div>
                ) : (
                    <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-6 py-2' onClick={() => onClose()}>{okLabel}</button>
                )}
            </div>
        </Modal>
    )
}

export default ConfirmModal
